import React from 'react';
import {Route, Routes} from 'react-router-dom';

// 页面组件
import Home from "../pages/Home";
import MonitorPage from "../pages/Monitor";
import About from "../pages/About";
import Demo from "../pages/Demo";
import NotFound from "../pages/NotFound";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/img-cloud/index.html" element={<Home />} />
      <Route path="/monitor" element={<MonitorPage />} />
      <Route path="/about" element={<About />} />
      <Route path="/demo" element={<Demo />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes; 